import { ReactElement } from "react";
import Modify from "@shared/FormTemplates/Modify";
import ModifyForm from "./ModifyForm";
import updateItem from "@services/Clients/RocketFactory/timeline/updateItem";
import useGetDetailItem from "@hooks/Clients/RocketFactory/timeline/useGetTimeline";
import validator from "@validators/Clients/RocketFactory/timeline/timeline.validate";
import formMapper from "@mappers/Clients/RocketFactory/timeline/timelineItem.mapper";

const ModifyItem = (): ReactElement => (
  <Modify
    CustomForm={ModifyForm}
    modifyHook={updateItem}
    detailHook={useGetDetailItem}
    validator={validator}
    formMapper={formMapper}
  />
);

export default ModifyItem;
